import Geometry from "@arcgis/core/geometry/Geometry";
import Graphic from "@arcgis/core/Graphic";
import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Message,
  MessageHeader,
  Modal,
} from "semantic-ui-react";

import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import Polygon from "@arcgis/core/geometry/Polygon.js";
import MapView from "@arcgis/core/views/MapView";

interface params {
  setOpen: (arg1: boolean) => void;
  graphic: Graphic;
  setIdentifyGeometry: (arg1: Polygon) => void;
  view: MapView;
}

const BufferModal = ({
  setOpen,
  graphic,
  setIdentifyGeometry,
  view,
}: params) => {
  const [submitted, setSubmitted] = useState(false);
  const [value, setValue] = useState(0);
  const [message, setMessage] = useState(null);
  const [valid, setValid] = useState(false);

  useEffect(() => {
    if (value) {
      if (value >= 1000) {
        setMessage("Must be less than or equal to 1000");
        setValid(false);
      } else if (value < 0) {
        setMessage("Must be greater than zero");
        setValid(false);
      } else {
        setMessage(null);
        setValid(true);
      }
    } else {
      setValid(false);
      setMessage(null);
    }
  }, [value]);

  const submit = () => {
    if (valid && value > 0 && value <= 1000) {
      const buff = geometryEngine.buffer(
        graphic.geometry,
        value,
        "feet"
      ) as Polygon;
      setIdentifyGeometry(buff);
      view.goTo(buff.extent);
      setOpen(false);
    }
  };

  return (
    <Modal
      onClose={() => setOpen(false)}
      open={true}
      closeOnDimmerClick={!submitted}
    >
      <Modal.Header style={{ fontSize: "1.1em" }}>Buffer Parcel</Modal.Header>
      <Modal.Content
        style={{ padding: "20px", margin: 0, textAlign: "Center" }}
      >
        {message && <Message negative>{message}</Message>}

        <p>
          Enter number of Feet to buffer the selected parcel to then identify
          features that intersect it
        </p>
        <Input
          type="number"
          focus
          placeholder="Select buffer in feet"
          style={{ width: "50%" }}
          onChange={(e, i) => setValue(parseFloat(i.value))}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button secondary onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button primary disabled={!valid} onClick={submit}>
          Submit
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default BufferModal;
